import { useRef } from "react";
function useCachedValue(value, cacheEnabled) {
  const ref = useRef(value);
  if (!cacheEnabled) {
    ref.current = value;
  }
  return ref.current;
}
export {
  useCachedValue
};
